import type { ReactNode } from "react";

interface ViewShipmentSectionProps {
  children: ReactNode;
  title: ReactNode | undefined;
  subtitle?: ReactNode | undefined;
  id: string;
  warn?: boolean | undefined;
}

function ShipmentSection(props: ViewShipmentSectionProps) {
  return (
    <div
      id={props.id}
      style={{
        width: "100%",
      }}
    >
      <div className="relative mb-12 w-full rounded-[3px] border border-border-strong px-10 pt-6 pb-10 [box-shadow:var(--color-shadow-ambient)_0px_3px_12px]">
        {props.warn && (
          <div
            style={{
              width: "100%",
              height: "16px",
              backgroundColor: "var(--color-gold)",
              marginBottom: "24px",
            }}
          ></div>
        )}
        {props.title && (
          <div className="text-3xl font-semibold text-foreground">
            {props.title}
          </div>
        )}
        {props.subtitle && (
          <div className="text-lg font-light text-content-muted">
            {props.subtitle}
          </div>
        )}
        {props.title && <div className="h-[32px]" />}
        {!props.title && <div className="h-[8px]" />}
        {props.children}
      </div>
    </div>
  );
}
export default ShipmentSection;
